import React, { Component } from "react";
import AntdTabs, {TabsProps} from "antd/lib/tabs";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DraggableTabs } from "./draggableTabs";
import PropTypes from "prop-types";
import "antd/lib/tabs/style";

const { TabPane } = AntdTabs;

interface TProps extends TabsProps {
  draggable: boolean;
}

class Tabs extends Component<TProps> {
  static propTypes = {
    draggable: PropTypes.bool
  };

  static defaultProps = {
    draggable: false
  };
  static TabPane = TabPane;

  render() {
    const { draggable } = this.props;
    return (
      <DndProvider backend={HTML5Backend}>
        {draggable ? (
          <DraggableTabs {...this.props} />
        ) : (
          <AntdTabs {...this.props} />
        )}
      </DndProvider>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/tabs/index.tsx